import { format, parseISO } from 'date-fns';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AppointmentFormFieldData } from '../../AppointmentForm.types';

export const useFormHeaderTitle = () => {
  'use memo';
  const { t } = useTranslation('common', { keyPrefix: 'mrp.appointmentForm' });
  const { control } = useFormContext<AppointmentFormFieldData>();
  const [activity, start = ''] = useWatch({
    name: ['activity', 'start'],
    control
  });

  const prefix = activity?.name || activity?.code || t('newAppointment');
  return `${prefix} (${format(parseISO(start), 'dd-MM')})`;
};
